import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";


import reportWebVitals from "./reportWebVitals";
import SimpleReactLightbox from "simple-react-lightbox";
window.process = { env: { NODE_ENV: 'development' } };
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter> 
      <SimpleReactLightbox>
        <App />
      </SimpleReactLightbox>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
